"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyMoneySchema = exports.AppleProxyMoneyAmountSchema = exports.appleProxyCurrencies = exports.AppleProxyCurrencySchema = exports.AppleProxyOrgRefSchema = exports.AppleProxyRefSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../core");
const utils_1 = require("../utils");
exports.AppleProxyRefSchema = typebox_1.Type.Integer({
    title: "Identifier",
    description: "Unique identifier for the given object.",
});
exports.AppleProxyOrgRefSchema = (0, utils_1.extendIntegerType)(exports.AppleProxyRefSchema, {
    title: "Org ID",
    description: "The identifier of the organization that owns the campaign. Your orgId is the same as your account in the Apple Search Ads UI.",
});
exports.AppleProxyCurrencySchema = (0, core_1.StringUnion)([
    "AUD",
    "CAD",
    "GBP",
    "JPY",
    "MXN",
    "NZD",
    // Not CNY!
    "RMB",
    "RUB",
    "USD",
    "EUR",
]);
exports.appleProxyCurrencies = exports.AppleProxyCurrencySchema.examples;
exports.AppleProxyMoneyAmountSchema = typebox_1.Type.String({
// TODO Could add regex validation (must be 2 decimal places)
});
exports.AppleProxyMoneySchema = (0, core_1.StrictObject)({
    currency: exports.AppleProxyCurrencySchema,
    amount: exports.AppleProxyMoneyAmountSchema,
});
